export default "__VITE_ASSET__C9JqRB94__"